import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ImprovementPlanConsequenceApiModel, ImprovementPlanListDeleteResultApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class ImprovementPlanConsequencesService extends CrudService<ImprovementPlanConsequenceApiModel, number> {
  public readonly apiUrl = 'improvement-plan-consequences';

  public deleteWithGuard(id: number): Observable<ImprovementPlanListDeleteResultApiModel> {
    return this.http.delete<ImprovementPlanListDeleteResultApiModel>(`${this.apiUrl}/delete/${id}`);
  }
}
